import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


const state = {
	apiUrl: 'http://api.senqiang.cn',
	adminUrl: 'http://admin.senqiang.cn',
}
export default new Vuex.Store({
  	state,
})

//生产
// http://api.senqiang.cn  服务器api
// http://h.senqiang.cn   服务器php-h5


//研发联调
//http://59.110.71.180:10053	海明api
//http://59.110.71.180:10013	严峰api
//http://59.110.71.180:10033	石星api
//http://59.110.71.180:10073	学庆api

//http://59.110.71.180:10102	lw m站
//http://59.110.71.180:10112	yk m站

//外网测试环境

//http://api.test.senqiang.cn  服务器api
//http://h.test.senqiang.cn   服务器php-h5

//http://api.test2.senqiang.cn  服务器api
//http://h.test2.senqiang.cn   服务器php-h5

//http://api.test3.senqiang.cn  服务器api
//http://h.test3.senqiang.cn   服务器php-h5

//http://api.test4.senqiang.cn  服务器api
//http://h.test4.senqiang.cn   服务器php-h5



// WEBPACK FOOTER //
// ./src/vuex/store.js